import React, { memo, ReactElement, SyntheticEvent, useCallback } from 'react'
import { Translate } from 'react-localize-redux'
import { NavLink, withRouter } from 'react-router-dom'
import { Breadcrumb } from 'antd'
import { isString } from 'lodash-es'
import { BasePathConst } from 'configs/Path.configs'
import { BreadcrumbName, breadcrumbNameMap } from './Breadcrumbs.helpers'
import { TBreadcrumbProps } from './Breadcrumbs.interfaces'
import styles from '../SecureLayout.module.scss'
import { RouterConfig } from 'core/utils/constants'

const AppBreadcrumb = (props: TBreadcrumbProps): ReactElement => {
  const { location, match, userId } = props

  const handleNavLinkClick = useCallback((event: SyntheticEvent, name: BreadcrumbName): void => {
    if (!isString(name) && name.disabled) {
      event.preventDefault()
    }
  }, [])

  const activePath = window.location.pathname || location.pathname
  const isMfePath = activePath.includes(RouterConfig.urlMap.unifiedUserManagement)
  const pathSnippets = activePath.split('/').filter(i => i)
  if (!isMfePath && pathSnippets.includes('administrators') && pathSnippets.includes(userId)) {
    const back = activePath
    if (back.includes("client-auth") || back.includes("create-api-Token")) {
      return (
        <Breadcrumb className={styles.breadcrumbWrap} separator={''}>
          <a
            onClick={(e) => {
              e.preventDefault()
              props.history.push(back.substring(0, back.lastIndexOf('/')))
            }}
            className={styles.activeBreadcrumb}
          >
            {<Translate id='common.form.buttons.backBtn'/>}
          </a>
        </Breadcrumb>
      )
    }

    return (
      <Breadcrumb className={styles.breadcrumbWrap} separator={''}>
        <a
          onClick={(e) => {
            e.preventDefault()
            props.history.goBack()
          }}
          className={styles.activeBreadcrumb}
        >
          {<Translate id='common.form.buttons.backBtn'/>}
        </a>
      </Breadcrumb>
    )
  }

  function extractParamsFromPath(path: string) {
    
    const segments = path.split('/')
    const dynamicSegmentParents = ['administrators']
    
    let id: string | undefined
    segments.forEach((seg, i) => {
      if (dynamicSegmentParents.includes(seg) && segments[i + 1]) {
        id = segments[i + 1]
      }
    })
  
    return { id }
  }

  const breadcrumbItems = pathSnippets.map((item, index) => {
    const url = `/${pathSnippets.slice(0, index + 1).join('/')}`
    const name = isMfePath
  ? breadcrumbNameMap(extractParamsFromPath(activePath))[url]
  : breadcrumbNameMap(match.params)[url]


    if (url === BasePathConst || !name) return null

    return (
      <Breadcrumb.Item key={url}>
        <NavLink
          onClick={(event) => handleNavLinkClick(event, name)}
          to={url}
          exact
          activeClassName={styles.activeBreadcrumb}
        >
          {isString(name) ? <Translate id={name} /> : <Translate id={name.label} />}
        </NavLink>
        {index < pathSnippets.length - 1 && <span className={styles.customSeparator}>/</span>}
      </Breadcrumb.Item>
    )
  })

  if (!location || !match) return <></>
  return (
    <Breadcrumb className={styles.breadcrumbWrap} separator={''}>
      {breadcrumbItems}
    </Breadcrumb>
  )
}

AppBreadcrumb.displayName = 'AppBreadcrumb'

export default withRouter<any, any>(memo(AppBreadcrumb))
